export const COLORS = {
  BACKGROUND: '#FBFCFE',
  BLUE: '#0076D1',
}

export const FONT_FAMILIES = {
  DEFAULT: 'Roboto',
}
